import PropTypes from 'prop-types';
import { makeStyles } from "@mui/styles";
import { CircularProgress, Grid, Paper, Box, Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        minHeight: "95vh",
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    gridItem: {
        width: "100%",
        padding: "1em",
        textAlign: "center",
    },
    paper: {
        minHeight: "70px",
        padding: "1em",
        display: "block", 
        alignItems: "center",
        justifyContent: "center",
    },
    typography: {
        variant: "caption",
        component: "div",
        color: "text.secondary",
        fontSize: "17px",
    }
}));

const CircularProgressWithLabel = (props) => {
    const classes = useStyles();
    return (
        <Grid container spacing={0} className={classes.root}>
            <Grid item xs={12} className={classes.gridItem}>
                <Paper elevation={3} className={classes.paper}>
                    <Typography className={classes.typography} sx={{marginBottom:"15px"}}>{props.label}</Typography> 
                    <Box sx={{ position: 'relative', justifyContent: 'center'}} >
                        <CircularProgress variant="determinate" {...props} size="4em"/>
                        <Box
                            sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                        >
                            <Typography className={classes.typography}>
                            {`${Math.round(props.value)}%`}
                            </Typography>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

export default CircularProgressWithLabel;